import React, { useEffect } from 'react';
import './HausnummerReminder.css';

/**
 * Hausnummer-Reminder nach erfolgreichem Speichern
 * Erinnert den User, die Hausnummer auf das Paket zu schreiben
 */
const HausnummerReminder = ({ hausnummer, onClose, onNext }) => {
  
  useEffect(() => {
    // Haptic Feedback beim Anzeigen
    if (navigator.vibrate) {
      navigator.vibrate([200, 100, 200]);
    }
  }, []);

  const handleNext = () => {
    if (onNext) onNext();
    if (onClose) onClose();
  };

  return (
    <div className="hausnummer-reminder-overlay">
      <div className="hausnummer-reminder">
        {/* Links: Icon + Text */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
          <span style={{ fontSize: '28px' }}>✅</span>
          <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'white' }}>
            PAKET GESPEICHERT
          </div>
        </div>
        
        {/* Mitte: Hinweis + Hausnummer */}
        <div style={{ 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '8px'
        }}>
          <div style={{ 
            fontSize: '16px', 
            color: 'white',
            fontWeight: '600',
            textAlign: 'center'
          }}>
            🖊️ Auf Paket schreiben:
          </div>
          
          <div style={{ 
            background: 'white', 
            padding: '8px 24px', 
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minWidth: '120px'
          }}>
            <span style={{ fontSize: '12px', color: '#666', fontWeight: 'bold', marginBottom: '2px' }}>
              HAUSNUMMER
            </span>
            <span style={{ fontSize: '32px', fontWeight: 'bold', color: '#4CAF50' }}>
              {hausnummer || '(?)'}
            </span>
          </div>
        </div>
        
        {/* Rechts: Button */}
        <button 
          onClick={handleNext}
          style={{
            background: 'white',
            color: '#4CAF50',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            whiteSpace: 'nowrap'
          }}
        >
          ✓ NÄCHSTES PAKET
        </button>
      </div>
    </div>
  );
};

export default HausnummerReminder;
